import axios, { AxiosInstance, AxiosResponse } from "axios";
import { Application } from "mdi-material-ui";
import { ApiErrorCode, ProblemDetails } from "src/types/ApiErrorResponse";
import ApplicationStore from "../stores/ApplicationStore";

let client = axios.create();

client.interceptors.request.use((request) => {
    if (request.method != 'get' && !request.url?.includes('get') && !request.url?.includes('duplicates')) {        
        //ApplicationStore.update(s => {
        //    s.showSaving = true;
        //});
    }

    return request;
}, (error) => {
    const problemDetails: ProblemDetails = error.response.data;

    switch (problemDetails.code) {
        case ApiErrorCode.EntityNotFound:
            //toast.error("EntityNotFound!");
            break;
        case ApiErrorCode.InvalidStatusChange:
            // toast.error(`Invalid Status Change! Allowed status: ${(problemDetails.additionalDetails.allowedStatus as string[]).join(', ')}`);
            break;
        default:
        // Do nothing and let specific custom business exception handling.
    }

    return Promise.reject(problemDetails);
});

client.interceptors.response.use((response: AxiosResponse<any>) => {
    ApplicationStore.update(s => {
        s.showSaving = false;
    });

    return response;
}, (error) => {
    ApplicationStore.update(s => {
        s.showSaving = false;
    });

    const problemDetails: ProblemDetails = error.response.data;

    switch (problemDetails.code) {
        case ApiErrorCode.EntityNotFound:
            //toast.error("EntityNotFound!");
            break;
        case ApiErrorCode.InvalidStatusChange:
            // toast.error(`Invalid Status Change! Allowed status: ${(problemDetails.additionalDetails.allowedStatus as string[]).join(', ')}`);
            break;
        default:
        // Do nothing and let specific custom business exception handling.
    }

    return Promise.reject(problemDetails);
});

export { client };

